module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "content1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "con1",
    attrs: {
      "id": "rfor"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/foreword#for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "rpre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "con1",
    attrs: {
      "id": "rChap01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#Chap01"
    }
  }, [_vm._v("True Learning")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#Chap02"
    }
  }, [_vm._v("A Little Learning")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#Chap03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schools Are Bad Places for Kids")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#Chap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fourth R: The Rat Race")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#Chap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teachers Talk Too Much")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#Chap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tyranny of Testing")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#Chap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not So Golden Rule Days")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#Chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Children Hate Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#Chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Order and Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#Chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teaching the Unteachable")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#Chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Education for the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#Chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blackboard Bungle")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#Chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Children in Prison")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#Chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comic Truth on an Urgent Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#Chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#Chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "con1",
    attrs: {
      "id": "rChap17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#Chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#Chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rChap19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/AbouttheAuthor#Chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0